import R from 'ramda'

const SEND_EMAIL_ACTION_TYPE = 'SEND_EMAIL'
const SEND_EMAIL_DISPLAY_TYPE = 'Send email'

const isSendEmailFormAction = R.propEq('type', SEND_EMAIL_DISPLAY_TYPE)

const getRecipients = R.applySpec({
  to: R.prop('address')
})

const convertSendEmailFormActionToWidgetAction = R.applySpec({
  type: R.always(SEND_EMAIL_ACTION_TYPE),
  recipients: getRecipients,
  subject: R.prop('subject'),
  body: R.prop('message')
})

export { isSendEmailFormAction, convertSendEmailFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/send-email.js